import React from 'react';
import { Gavel, Balance, Shield, Warning } from '@mui/icons-material';
import PageHero from '../components/common/PageHero';
import PageLayout from '../components/common/PageLayout';
import ContentSection from '../components/common/ContentSection';
import ContactSection from '../components/common/ContactSection';

const TermsOfServicePage = () => {
    const sections = [
        {
            title: "Acceptance of Terms",
            icon: <Gavel />,
            content: [
                "By accessing and using Sortify, you accept and agree to be bound by these Terms of Service",
                "If you do not agree to these terms, you may not use our service",
                "We reserve the right to update these terms at any time with notice to users",
                "Continued use of the service after changes constitutes acceptance of new terms",
                "These terms apply to all users, including registered and guest users"
            ]
        },
        {
            title: "User Responsibilities",
            icon: <Balance />,
            content: [
                "Provide accurate information when creating your account",
                "Use the service only for lawful waste classification purposes",
                "Do not upload inappropriate, harmful, or copyrighted images",
                "Respect other users and maintain a positive community environment",
                "Report any bugs, security issues, or inappropriate content to our team"
            ]
        },
        {
            title: "Service Limitations",
            icon: <Warning />,
            content: [
                "AI classification results are for guidance only and may not be 100% accurate",
                "Users should verify disposal methods with local waste management authorities",
                "Service availability may be interrupted for maintenance or technical issues",
                "We do not guarantee the service will meet all your specific requirements",
                "Classification accuracy may vary based on image quality and waste type"
            ]
        },
        {
            title: "Liability and Disclaimers",
            icon: <Shield />,
            content: [
                "Sortify is provided 'as is' without warranties of any kind",
                "We are not liable for damages arising from use of incorrect classification",
                "Users are responsible for verifying disposal methods with local authorities",
                "Our liability is limited to the maximum extent permitted by law",
                "Environmental impact and disposal effectiveness may vary by location"
            ]
        }
    ];

    return (
        <PageLayout
            showIntroduction={true}
            introTitle="📋 Terms of Service"
            introContent={
                <>
                    Welcome to Sortify! These Terms of Service govern your use of our AI-powered waste
                    classification platform. By using Sortify, you agree to these terms which are designed
                    to ensure a safe, effective, and positive experience for all users.
                    <br/><br/>
                    Please read these terms carefully. If you have any questions about these terms,
                    please contact us at <strong>legal@sortify.com</strong>.
                </>
            }
        >
            <PageHero
                title="Terms of Service"
                subtitle="Your agreement for using Sortify's AI-powered waste classification service"
                emoji="📝"
                badge={`Effective Date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}`}
            />

            {/* Main Sections */}
            {sections.map((section, index) => (
                <ContentSection
                    key={index}
                    title={section.title}
                    icon={section.icon}
                    content={section.content}
                />
            ))}

            {/* Contact Section */}
            <ContactSection />
        </PageLayout>
    );
};

export default TermsOfServicePage;
